// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1qmXl","empty":"ModalGraph_empty__3jNIi"};